import { render } from "./AddWebPlan.vue?vue&type=template&id=446241b4&scoped=true"
import script from "./AddWebPlan.vue?vue&type=script&lang=js"
export * from "./AddWebPlan.vue?vue&type=script&lang=js"

import "./AddWebPlan.vue?vue&type=style&index=0&id=446241b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446241b4"]])

export default __exports__